/**
 * Created by emilgrabowiec on 09.05.2016.
 */
$(() => {
  let currentPage = 1;
  let maxPages;
  let pendingRequest = false;
  let copiesToReport = null;
  let titleToReport = null;
  let searchType = null;
  let loadingTimeout = null;
  let hasRecording = false;

  populateFormFromGet();

  $('input[name="type"]').click(() => {
    const url = `${urlSubmissionTitle}?type=${$('input[name="type"]:checked').val()}`;

    $('#manual-submit').attr('href', url);
  });

  $('.next-page').click((e) => {
    if (!pendingRequest && parseInt(currentPage) < parseInt(maxPages)) {
      currentPage++;
      $('#search-title').submit();
    }

    e.preventDefault();
  });

  $('.previous-page').click((e) => {
    if (!pendingRequest && parseInt(currentPage) > 1) {
      currentPage--;
      $('#search-title').submit();
    }

    e.preventDefault();
  });

  $('.page-number-input').donetyping(function () {
    const nextPage = parseInt($(this).val());

    if (!isNaN(nextPage)) {
      if (nextPage >= 1 && nextPage <= maxPages) {
        currentPage = nextPage;
        $('#search-title').submit();
      }
    } else {
      $(this).val(currentPage);
    }
  });

  $('#search-title').submit(function (e) {
    if (!pendingRequest) {
      pendingRequest = true;
      searchType = $('#search-title input[name=type]:checked').val();
      const term = $('#search-title input[name=term]').val();

      $('#search-overlay').show();
      $(this).find('button').button('loading');

      const form = $(this);
      const dataArr = $(this).serializeArray();

      $.post(urlSearchForTracks, {
        dataArr,
        page: currentPage
      }, (data) => {
        pendingRequest = false;

        $('#search-overlay').hide();
        form.find('button').button('reset');

        if (data.isError === 1) {
          toastr.error(data.msgError, 'Error');
        } else {
          maxPages = data.pages;

          $('#results-count').html(data.results);
          $('.page-count').html(`of ${data.pages}`);

          $('div.result-info, div.result-info2').show();
          $('div.not-find-info').show();
          $('.search-music-wrapper .search-music-results').html(data.html);

          $('.page-number-input').val(data.currentPage);

          if (parseInt(data.pages) > 0) {
            $('div.page-pagination-div').show();
          } else {
            $('div.page-pagination-div').hide();
          }

          if (data.term == '') {
            $('#search-term').html(' results');
          } else {
            $('#search-term').html(` matching results for <em>"${data.term}"</em>`);
          }

          $('#manual-submit').attr('href', function () {
            return `${this.href}&term=${term}`;
          });
        }

        /* build current search url */
        let formTerm = $('input[name="term"]').val();
        formTerm = encodeURIComponent(formTerm);

        history.pushState({}, null, `${urlSearch}?${jQuery.param({
          term: formTerm,
          page: currentPage,
          type: $('input[name="type"]:checked').val()
        })}`);
      });
    }

    e.preventDefault();
  });

  $('#reportModal').on('show.bs.modal', (e) => {
    const btn = $(e.relatedTarget);
    let copies = btn.parent().find('input.copies').val();
    let label = ' copies';

    if (copies == '' || isNaN(copies) || copies <= 0) copies = '1';

    if (copies == 1) label = ' copy';

    $('#report-title').html(`"${btn.data('title')}"`);
    $('#report-copies').html(`Reporting ${copies}${label}`);

    copiesToReport = copies;
    titleToReport = btn.data('id-item');

    $('form#track .form-group').removeClass('has-error').find('.help-block').remove();
    clearForm('track');
    clearTimeout(loadingTimeout);
    $('#reportModal .modal-body').removeClass('has-form');
    $('#reportModal .recording-form').hide();
    $('#reportModal .bottom-button button').hide();
    $('#reportModal .bottom-button img').hide();

    loadingTimeout = setTimeout(() => {
      $('#reportModal .bottom-button img').show();
    }, 500);
    $.post(urlCheckForRecording, {
      id: titleToReport
    }, (data, b) => {
      if (!data.isError) {
        clearTimeout(loadingTimeout);
        hasRecording = data.hasRecording;
        if (!hasRecording && searchType === 'commercial') {
          $('#reportModal .modal-body').addClass('has-form');
          setTimeout(() => {
            $('#reportModal .recording-form').fadeIn();
            $('#reportModal .bottom-button button').fadeIn();
          }, 320);
        } else {
          $('#reportModal .bottom-button button').fadeIn();
        }

        $('#reportModal .bottom-button img').hide();
      }
    });
  });


  $('#reportModal').on('hide.bs.modal', (e) => {
    $('#reportModal .alert-danger').hide();
  });

  $('#reportModal button[name="submit-view"], #reportModal button[name="submit-continue"]').click(function () {
    $('#reportModal .alert-danger').hide();

    const action = $(this).attr('name') === 'submit-continue' ? 'continue' : 'view';
    const btnParent = $(this).parent().parent();
    const recordingForm = btnParent.parent().find('form#track');

    recordingForm.find('.form-group').removeClass('has-error').find('.help-block').remove();
    btnParent.find('button').button('loading');

    $.post(urlReportTrack, {
      copies: copiesToReport,
      id: titleToReport,
      type: searchType,
      recordingData: recordingForm.serializeArray()
    }, (data, b) => {
      btnParent.find('button').button('reset');

      if (data.isError == 1) {
        $('#reportModal .alert-danger').html(data.msgError);
        $('#reportModal .alert-danger').show();

        if (data.formErrorMessagess) {
          $.each(data.formErrorMessagess, (elementId, value) => {
            $.each(value, (index, value) => {
              recordingForm.find(`[name="${elementId}"]`).parent().addClass('has-error').append(`<p for="${elementId}" generated="true" class="help-block">${value}</p>`);
            });
          });
        }
      } else {
        copiesToReport = null;
        titleToReport = null;

        if (action == 'view') {
          window.location.href = urlReportTracks;
        } else {
          $('#reportModal').modal('hide');
        }
      }
    });
  });

  $('#search-title').submit();

  function populateFormFromGet() {
    const params = {};
    var url = window.location.href;

    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      key = decodeURIComponent(key);
      value = decodeURIComponent(value);
      params[key] = value;
    });

    if ('term' in params) {
      const term = decodeURIComponent(params.term);
      $('input[name="term"]').val(term);
    }
    if ('type' in params) {
      var url = `${urlSubmissionTitle}?type=${params.type}`;

      $('#manual-submit').attr('href', url);
      $(`#${params.type}`).attr('checked', 'checked');
    }
    if ('page' in params) currentPage = params.page;
  }
});

function clearForm(idForm) {
  $('INPUT:text, INPUT:password, INPUT:file, SELECT, TEXTAREA', `#${idForm}`).val('');
  $('INPUT:checkbox, INPUT:radio', `#${idForm}`).removeAttr('checked').removeAttr('selected');
}
